import { Link } from 'react-router';
import { PageHeader } from '@/components/common/PageHeader';
import { PageMeta } from '@/components/common/PageMeta';
import { Button } from '@/components/ui/button';
import { Routes } from '@/constants/routes';
import { RouteErrorPage } from '@/pages/RouteError/data';

export default function RouteError() {
  function handleReload() {
    window.location.reload();
  }

  return (
    <>
      <PageMeta title={RouteErrorPage.title} description={RouteErrorPage.description} noIndex />
      <PageHeader title={RouteErrorPage.title} description={RouteErrorPage.description}>
        <Button onClick={handleReload}>{RouteErrorPage.reloadLabel}</Button>
        <Button asChild variant="outline">
          <Link to={Routes.home}>{RouteErrorPage.homeLinkLabel}</Link>
        </Button>
      </PageHeader>
    </>
  );
}